export const SOLD_LAST_ITEM_IN_THIS_SIZE = 'Sorry, we just sold the last item in this size.';

export const YOU_JUST_MISSED_IT = 'You just missed it!';
